import { InteractionStatus } from '@azure/msal-browser'
import { msalState } from '@/plugins/msalPlugin'

export function useMsal () {
  const { instance, accounts, inProgress } = msalState
  if (!instance || !accounts || !inProgress) {
    // eslint-disable-next-line no-throw-literal
    throw 'Please install the msalPlugin'
  }

  if (inProgress === InteractionStatus.Startup) {
    instance.handleRedirectPromise().catch(() => {
      // Errors should be handled by listening to the LOGIN_FAILURE event
      // return
    })
  }
  return {
    instance: instance,
    accounts,
    inProgress,
  }
}
